import { z } from 'zod';
/** A browser where the user is signed in (doc 25). */
export const DeviceSessionSchema = z.object({
    id: z.string(),
    device: z.string(),
    browser: z.string(),
    createdAt: z.string(),
    lastSeenAt: z.string(),
    current: z.boolean(),
});
export const DeviceSessionsResponseSchema = z.object({ sessions: z.array(DeviceSessionSchema) });
//# sourceMappingURL=sessions.js.map